/**
 * @param {{
 *   title: string;
 *   message: string;
 *   confirmLabel?: string;
 *   cancelLabel?: string;
 * }} options
 * @returns {Promise<boolean>}
 */
export function showConfirmModal({
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
}) {
  const root = document.getElementById('confirm-modal');
  const titleEl = document.getElementById('confirm-modal-title');
  const messageEl = document.getElementById('confirm-modal-message');
  const confirmBtn = /** @type {HTMLButtonElement | null} */ (
    document.getElementById('confirm-modal-confirm')
  );
  const cancelBtn = /** @type {HTMLButtonElement | null} */ (
    document.getElementById('confirm-modal-cancel')
  );
  const backdrop = root?.querySelector('.confirm-modal__backdrop');

  if (!root || !titleEl || !messageEl || !confirmBtn || !cancelBtn) {
    return Promise.resolve(false);
  }

  titleEl.textContent = title;
  messageEl.textContent = message;
  confirmBtn.textContent = confirmLabel;
  cancelBtn.textContent = cancelLabel;

  return new Promise((resolve) => {
    const previousFocus = document.activeElement;

    const close = (confirmed) => {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeyDown);
      confirmBtn.removeEventListener('click', onConfirm);
      cancelBtn.removeEventListener('click', onCancel);
      backdrop?.removeEventListener('click', onCancel);
      if (previousFocus instanceof HTMLElement) previousFocus.focus();
      resolve(confirmed);
    };

    const onConfirm = () => close(true);
    const onCancel = () => close(false);
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onCancel();
    };

    confirmBtn.addEventListener('click', onConfirm);
    cancelBtn.addEventListener('click', onCancel);
    backdrop?.addEventListener('click', onCancel);
    document.addEventListener('keydown', onKeyDown);

    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    cancelBtn.focus();
  });
}
